import { Injectable, signal } from '@angular/core';

export type ToastColor = 'success' | 'danger' | 'warning' | 'info';

export type ToastEntry = {
	id: string;
	title: string;
	text: string;
	color: ToastColor;
	duration: number;
};

@Injectable({ providedIn: 'root' })
export class ToastService {
	private readonly entries = signal<ToastEntry[]>([]);
	readonly toasts = this.entries.asReadonly();

	show(input: { title: string; text: string; color?: ToastColor; duration?: number }) {
		const id = crypto.randomUUID();
		const duration = input.duration ?? 5000;

		this.entries.update((list) => [
			...list,
			{
				id,
				title: input.title,
				text: input.text,
				color: input.color ?? 'info',
				duration
			}
		]);

		if (duration > 0) {
			setTimeout(() => this.dismiss(id), duration);
		}
	}

	success(title: string, text: string) {
		this.show({ title, text, color: 'success' });
	}

	error(title: string, text: string) {
		this.show({ title, text, color: 'danger', duration: 7000 });
	}

	warning(title: string, text: string) {
		this.show({ title, text, color: 'warning' });
	}

	info(title: string, text: string) {
		this.show({ title, text, color: 'info' });
	}

	dismiss(id: string) {
		this.entries.update((list) => list.filter((item) => item.id !== id));
	}
}
